import { useEffect, useRef, useState } from "react";

function isOverflowing(element) {
    return element.scrollHeight > element.clientHeight;
}

export function useIsScrolled(): { isScrollable: boolean; ref: any } {
    const currentRef = useRef<HTMLDivElement>(null);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const isScrollable =
            currentRef.current &&
            isOverflowing(currentRef.current) &&
            ["scroll", "auto"].includes(window.getComputedStyle(currentRef.current).overflowY);
        setIsScrollable(isScrollable);
    }, [currentRef.current]);

    return { isScrollable, ref: currentRef };
}
